/** Bullet list of perks shown inside the main Reserve CTA card. */
export const reservePerks: ReadonlyArray<string> = [
  '<b>Founder enamel pin</b> — exclusive founder edition',
  '<b>Triple your character slots</b> (3 total)',
  "<b>Founding Backer badge</b> — displayed in-app",
  "<b>+6 bonus months</b> on your selected pledge tier",
  '<b>Guaranteed</b> early campaign access',
  '<b>Priority tier</b> selection at launch',
  '<b>Beta access</b> to GM & Homebrew toolkits as they drop',
  '<b>New Quests</b> added throughout the campaign',
];
